import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { GrowingAmountDisplay } from '../../components/growingAmountDisplay';
import { BAD_BEAT_JACKPOT_AMOUNT_BASE_CSS } from '../../types/badBeatJackpotTypes';
import { EntrySidePanel } from './components/entrySidePanel';
const AMOUNT_CSS = css(BAD_BEAT_JACKPOT_AMOUNT_BASE_CSS, css `
    font-size: 120%;
  `);
export const EntryBadBeatJackpotDisplay = ({ badBeatJackpotAmount }) => {
    return (_jsx(EntrySidePanel, { title: '\uD83D\uDCB0 Bad Beat Jackpot', contentsContainerStyle: { textAlign: 'right' }, gameGuidePage: 'bad-beat-jackpot', children: _jsxs(Typography, { variant: 'h6', children: [_jsx("span", { css: AMOUNT_CSS, children: _jsx(GrowingAmountDisplay, { amount: badBeatJackpotAmount }) }), ' ', "Chips"] }) }));
};
